import { AspectRatio, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const Material = () => {
  return (
    <Flex
      w="100%"
      flexDir={{
        base: 'column',
        sm: 'row'
      }}
      justifyContent="space-between"
      alignItems="center"
      gap={10}
      pt={{
        base: '40px',
        sm: '10px',
        md: '40px'
      }}
    >
      <VStack
        w={{
          base: '100%',
          sm: '75%',
          xl: '90%',
          '2xl': '100%'
        }}
        mt={{
          base: 0,
          lg: 0,
          xl: '10px'
        }}
        alignItems="flex-start"
      >
        <HStack gap={20} justifyContent="center" alignItems="flex-end">
          <AspectRatio
            w={{
              base: '100px',
              sm: '100px',
              md: '120px',
              lg: '150px',
              xl: '200px'
            }}
            ratio={1 / 1}
            position="relative"
            zIndex={10}
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-premium-1711632721467.png"
              alt="icon premium"
              fill
            />
          </AspectRatio>

          <VStack gap={0}>
            <AspectRatio
              w={{
                base: '70px',
                sm: '70px',
                md: '70px',
                lg: '100px',
                xl: '150px'
              }}
              ratio={147 / 33}
              position="relative"
              zIndex={10}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/inner-wall-1711632721466.png"
                alt="inner wall text"
                fill
              />
            </AspectRatio>
            <AspectRatio
              w={{
                base: '100px',
                sm: '100px',
                md: '120px',
                lg: '150px',
                xl: '200px'
              }}
              ratio={1 / 1}
              position="relative"
              zIndex={10}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-inner-1711632721465.png"
                alt="tumbler inner"
                fill
              />
            </AspectRatio>
          </VStack>
        </HStack>

        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w={{
            base: '80%',
            lg: '60%'
          }}
          zIndex={100}
          mt={5}
        >
          PREMIUM STAINLESS STEEL CONSTRUCTION
        </Text>
        <Text
          textStyle="gripContentSmall"
          textAlign="left"
          w={{
            base: '100%',
            sm: '90%',
            lg: '90%',
            xl: '80%'
          }}
          zIndex={100}
        >
          Crafted with care, the Arctic Grip Tumbler boasts a 304 high-quality
          stainless steel inner wall, ensuring your beverages remain untainted
          and pure. The durable 18/8 stainless steel outer wall adds robustness
          to the tumbler, making it your reliable companion for years to come.
        </Text>
      </VStack>

      <VStack
        w={{
          base: '100%',
          sm: '20%'
        }}
        mt={{
          base: 0,
          sm: '20px'
        }}
        position="relative"
        display={{
          base: 'flex',
          lg: 'none'
        }}
      >
        <AspectRatio
          w={{
            base: '200px',
            sm: '240px',
            md: '300px'
          }}
          ratio={330 / 460}
          position="relative"
          zIndex={10}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-material-1711632721464.png"
            alt="tumbler material"
            fill
          />
        </AspectRatio>
      </VStack>
    </Flex>
  )
}

export default Material
